import React, { Component } from "react";

import {
  Modal, DataTable
} from "@shopify/polaris";

import "./index.css";

// import utils from '../../utils/utils';

import Language from '../../i18n/Language';

const t = Language

class ImportRedirectFailureModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      FailedLogActive:props.FailedLogActive
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.FailedLogActive !== this.state.FailedLogActive) {
      let FailedLogActive = nextProps.FailedLogActive;
      this.setState({
        FailedLogActive: FailedLogActive,
      })
    }
    return true
  }

  CloseFailedLog = () =>{
    this.props.CloseFailedLog()
  }

  render() {
  
    return (
      <div style={{maxHeight: '400px'}} >
      <Modal
        open={this.state.FailedLogActive}
        onClose={this.CloseFailedLog}
        title="Failed log"
        secondaryActions={[
          {
            content: "Close",
            onAction: this.CloseFailedLog
          }
        ]}
        
      >
        <Modal.Section>
          <DataTable
          columnContentTypes={[
            'text',
            'text',
            'text',
          ]}
          headings={[
            t("Path"),
            t("Target"),
            t("Status"),
          ]}
          rows={this.props.imFailedLogRows}
        />
        </Modal.Section>
      </Modal>
      </div>
    );
  }
}

export default ImportRedirectFailureModel;